// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type ButtonIconOption = DataOption<IconPresentationProps["src"]>;
export interface ButtonIconOptionMapper {
    none: ButtonIconOption;
    arrowForward: ButtonIconOption;
    arrowBackward: ButtonIconOption;
    chevronRight: ButtonIconOption;
    chevronLeft: ButtonIconOption;
}
export type ButtonIconOptions = DataOptions<ButtonIconOption> & ButtonIconOptionMapper;
export type ButtonIcon = LiteralUnion<keyof ButtonIconOptionMapper>;

export const buttonIconOptions: ButtonIconOptions = {
    none: { id: "none", displayName: "None", value: "", isDefault: true },
    arrowForward: { id: "arrowForward", displayName: "Arrow Forward", value: ArrowForward },
    arrowBackward: { id: "arrowBackward", displayName: "Arrow Backward", value: ArrowBackward },
    chevronRight: { id: "chevronRight", displayName: "Chevron Right", value: ChevronRight },
    chevronLeft: { id: "chevronLeft", displayName: "Chevron Left", value: ChevronLeft },
};

export type ButtonIconFieldValue = ButtonIcon | undefined;
export interface ButtonIconFieldOptions {
    isChildDefinition?: boolean;
}

export const getButtonIconFieldData = (value: ButtonIconFieldValue, options?: ButtonIconFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(buttonIconOptions, value);
};

export const getButtonIconFieldDefinition = (name: string, options?: ButtonIconFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(buttonIconOptions),
        name,
        displayName: "Button Icon",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getButtonIconField = (name: string, options?: ButtonIconFieldOptions) => {
    const parse = (value: ButtonIconFieldValue) => getButtonIconFieldData(value, options);

    return {
        definition: getButtonIconFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getButtonIconField;
